import { render, staticRenderFns } from "./MtipytamequipamientoGrid.vue?vue&type=template&id=572a1bf8"
import script from "./MtipytamequipamientoGrid.vue?vue&type=script&lang=js"
export * from "./MtipytamequipamientoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports